// extracted by mini-css-extract-plugin
module.exports =  {"container":"container_YzufOgOS","title":"title_Sd_1bjP7","info":"info_sAQCkVPU","heading":"heading_UpQR1dvR"};